import { afterNextRender, booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { InputFieldSelectionBaseComponent } from './input-field-selection-base.component';
import { MatButtonToggle, MatButtonToggleChange, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { IMessageResolvers } from './message.helper';
import { ReactiveFormsModule } from '@angular/forms';
import { MatError } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';

const messageResolver: IMessageResolvers = { required: 'Eine Auswahl ist erforderlich' };

@Component({
  selector: 'mng-inputfield-buttongroup-selection',
  imports: [MatButtonToggleGroup, ReactiveFormsModule, MatButtonToggle, MatError, MatTooltip],
  template: `
    <div class="mat-form-field">
      <mat-button-toggle-group
        #group="matButtonToggleGroup"
        class="role_toggle mng-toggle-buttons"
        hideSingleSelectionIndicator="true"
        [formControl]="field().control"
      >
        @for (option of options(); track option) {
          <mat-button-toggle [value]="option.value" [matTooltip]="getTooltip(option)" (change)="onChange($event)">
            <div [innerHTML]="getRealOptionLabel(option)"></div>
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
      @if (hasErrors && showError() && field().control.enabled && field().control.touched) {
        <div style="margin-top: 5px;">
          <mat-error style="font-size: 13.5px;"> {{ validationMessage }} </mat-error>
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFieldButtongroupSelectionComponent extends InputFieldSelectionBaseComponent {
  readonly abwaehlenErlaubt = input(false, { transform: booleanAttribute });

  readonly selectionChangeHandler = input((value: unknown) => {
    return;
  });
  readonly selectionChange = output<unknown>();

  // wird nur fuer das "abwaehlen Verhalten" benötigt
  #currentValue: any;

  constructor() {
    super();
    afterNextRender(() => {
      if (this.abwaehlenErlaubt) {
        this.#currentValue = this.field().control.value;
      }
    });
  }

  onChange(matButtonToggleChange: MatButtonToggleChange) {
    // Spezielles Handling um auch "deselektieren" zu können
    if (this.abwaehlenErlaubt()) {
      if (matButtonToggleChange.value && matButtonToggleChange.value === this.#currentValue) {
        this.field().control.setValue(undefined);
        this.field().control.markAsDirty();
        this.#currentValue = undefined;
        this.selectionChangeHandler()(undefined);
        this.selectionChange.emit(undefined);
      } else {
        this.selectionChangeHandler()(matButtonToggleChange.value);
        this.selectionChange.emit(matButtonToggleChange.value);
        this.#currentValue = matButtonToggleChange.value;
      }
    } else {
      this.selectionChangeHandler()(matButtonToggleChange.value);
      this.selectionChange.emit(matButtonToggleChange.value);
    }
  }

  customMessageResolver(): IMessageResolvers | undefined {
    return messageResolver;
  }
}
